"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardRowDivided = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const CardRowDivided = (props) => ((0, jsx_runtime_1.jsxs)(Wrapper, { className: props.className, children: [(0, jsx_runtime_1.jsx)("div", { children: props.left }, void 0), (0, jsx_runtime_1.jsx)("div", { children: props.right }, void 0)] }, void 0));
exports.CardRowDivided = CardRowDivided;
const Wrapper = styled_components_1.default.div `
  align-items: center;
  display: flex;
  padding: ${({ theme }) => theme.spacings.xs} 0;
  width: 100%;

  & > div {
    line-height: 1.5rem;
  }

  & > div:first-of-type {
    flex: 3;
  }

  & > div:last-of-type {
    flex: 7;
    padding-left: ${({ theme }) => theme.spacings.m};
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    & > div:first-of-type {
      flex: 4;
    }

    & > div:last-of-type {
      flex: 6;
      word-break: break-word;
    }
  }
`;
//# sourceMappingURL=index.js.map